import { STORE_UI } from 'Core/constants'

import HistoryStore from '../historyStore/HistoryStore'
import UIStore from '../uiStore/UIStore'

export default class BasicRootStore extends HistoryStore {
	[STORE_UI]: UIStore<BasicRootStore>

	constructor() {
		super()
		Object.assign(this, {
			[STORE_UI]: new UIStore(this)
		})
	}
}
